import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faEdit,
  faSync,
  faArrowUp,
  faArrowDown,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Roles.css"; // puedes reutilizar Usuarios.css si quieres

import {
  getRoles,
  saveRol,
  deleteRol,
} from "../../../services/rolservice";

export default function Roles() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filtroId, setFiltroId] = useState("");
  const [filtroRol, setFiltroRol] = useState("");
  const [ordenInvertido, setOrdenInvertido] = useState(false);

  const [modalNuevo, setModalNuevo] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);

  const [nuevoRol, setNuevoRol] = useState({ rol: "" });
  const [rolEdit, setRolEdit] = useState({ idrol: 0, rol: "" });

  const [saving, setSaving] = useState(false);

  // =========================
  // CARGAR ROLES
  // =========================
  const cargarRoles = async () => {
    setLoading(true);
    const data = await getRoles();
    if (!data) {
      toast.error("No se pudieron cargar los roles");
      setLoading(false);
      return;
    }
    setRoles(data);
    setLoading(false);
  };

  useEffect(() => {
    cargarRoles();
  }, []);

  // =========================
  // FILTROS
  // =========================
  const rolesFiltrados = roles.filter((r) => {
    const idMatch = r.idrol.toString().includes(filtroId);
    const rolMatch = r.rol.toLowerCase().includes(filtroRol.toLowerCase());
    return idMatch && rolMatch;
  });

  // =========================
  // ACCIONES
  // =========================
  const abrirNuevo = () => setModalNuevo(true);
  const cerrarNuevo = () => {
    setModalNuevo(false);
    setNuevoRol({ rol: "" });
  };

  const abrirEditar = (rol) => {
    setRolEdit(rol);
    setModalEditar(true);
  };

  const cerrarEditar = () => {
    setModalEditar(false);
    setRolEdit({ idrol: 0, rol: "" });
  };

  const guardarNuevo = async () => {
    if (!nuevoRol.rol) return toast.error("Ingrese el nombre del rol");
    if (saving) return;

    setSaving(true);
    const res = await saveRol({ rol: nuevoRol.rol });

    if (res.res === 1) {
      toast.success(res.mensaje || "Rol creado");
      cerrarNuevo();
      cargarRoles();
    } else {
      toast.error(res.mensaje || "No se pudo guardar");
    }
    setSaving(false);
  };

  const guardarEditar = async () => {
    if (!rolEdit.rol) return toast.error("Ingrese el nombre del rol");
    if (saving) return;

    setSaving(true);
    const res = await saveRol(rolEdit);

    if (res.res === 1) {
      toast.success(res.mensaje || "Rol actualizado");
      cerrarEditar();
      cargarRoles();
    } else {
      toast.error(res.mensaje || "No se pudo actualizar");
    }
    setSaving(false);
  };

  const eliminar = async (idrol) => {
    if (!window.confirm("¿Eliminar rol?")) return;

    const res = await deleteRol(idrol);

    if (res.res === 1) {
      toast.success(res.mensaje || "Rol eliminado");
      cargarRoles();
    } else {
      toast.error(res.mensaje || "No se pudo eliminar");
    }
  };

  const recargar = () => {
    cargarRoles();
    toast.success("Roles recargados");
  };

  const invertirOrden = () => {
    setRoles([...roles].reverse());
    setOrdenInvertido(!ordenInvertido);
  };

  return (
    <div>
      <ToastContainer />

      {/* HEADER */}
      <div className="deFlexContent">
        <div className="nuevo-container">
          <button className='nuevo'  onClick={abrirNuevo}>
            <FontAwesomeIcon icon={faPlus} />
            <span> Nuevo</span>
          </button>
        </div>

        <div className="filtrosContain">
          <input
            type="number"
            placeholder="ID"
            value={filtroId}
            onChange={(e) => setFiltroId(e.target.value)}
            className="input-modal"
          />

          <input
            type="text"
            placeholder="Rol"
            value={filtroRol}
            onChange={(e) => setFiltroRol(e.target.value)}
            className="input-modal"
          />

          <button className="reload" onClick={recargar}>
            <FontAwesomeIcon icon={faSync} />
          </button>

          <button className="reverse" onClick={invertirOrden}>
            <FontAwesomeIcon
              icon={ordenInvertido ? faArrowUp : faArrowDown}
            />
          </button>
        </div>
      </div>

      {/* TABLA */}
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Rol</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="3">Cargando...</td>
              </tr>
            ) : (
              rolesFiltrados.map((r) => (
                <tr key={r.idrol}>
                  <td>{r.idrol}</td>
                  <td className="rolAdmin">{r.rol}</td>
                  <td>
                    <button
                      className="eliminar"
                      onClick={() => eliminar(r.idrol)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>

                    <button
                      className="editar"
                      onClick={() => abrirEditar(r)}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL NUEVO */}
      {modalNuevo && (
        <div className="modalOverlay" onClick={cerrarNuevo}>
          <div className="modalWindow" onClick={(e) => e.stopPropagation()}>
            <div className="modalHeader">
              <h2>Nuevo Rol</h2>
              <button onClick={cerrarNuevo} className="modalCloseX">×</button>
            </div>

            <div className="modalBody">
              <input
                placeholder="Nombre del rol"
                value={nuevoRol.rol}
                onChange={(e) =>
                  setNuevoRol({ rol: e.target.value })
                }
                className="input-modal"
              />
            </div>

            <div className="modalFooter">
              <button onClick={cerrarNuevo} className="modalBtn btnCancelar">Cancelar</button>
              <button onClick={guardarNuevo} className="modalBtn btnGuardar" disabled={saving}>
                {saving ? "Guardando..." : "Guardar"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL EDITAR */}
      {modalEditar && (
        <div className="modalOverlay" onClick={cerrarEditar}>
          <div className="modalWindow" onClick={(e) => e.stopPropagation()}>
            <div className="modalHeader">
              <h2>Editar Rol</h2>
              <button onClick={cerrarEditar} className="modalCloseX">×</button>
            </div>

            <div className="modalBody">
              <input
                placeholder="Nombre del rol"
                value={rolEdit.rol}
                onChange={(e) =>
                  setRolEdit({ ...rolEdit, rol: e.target.value })
                }
                className="input-modal"
              />
            </div>

            <div className="modalFooter">
              <button onClick={cerrarEditar} className="modalBtn btnCancelar">Cancelar</button>
              <button onClick={guardarEditar} className="modalBtn btnGuardar" disabled={saving}>
                {saving ? "Guardando..." : "Actualizar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
